import { authHeader } from "../../../helpers/authHeader";
import axios from "axios";


export default {
    loadDimensions,
    loadProductGroups,
    loadProductCategories,
    loadSuppliers,
    loadCountries,
    loadBrands,
    findProducts,
    duplicateProduct,
    updateProduct,
    loadWarehouses,
};


function loadDimensions() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/products/dimensions", requestOptions)
        .then((response) => {
            if (response.data.length === 0) {
                return {};
            }
            let dimensions = {};
            for (let key in response.data) {
                dimensions[response.data[key].id] = response.data[key];
            }

            return dimensions;
        }, () => {
            Promise.reject(["failed to load Dimensions"]);
        });
}

function loadProductGroups() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/productGroup/376423", requestOptions)
        .then((response) => {
            return response.data.data;
        }, () => {
            Promise.reject(["failed to load ProductGroups"]);
        });
}


function loadProductCategories() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/productCategory/376423", requestOptions)
        .then((response) => {
            return response.data.data;
        }, () => {
            Promise.reject(["failed to load ProductCategory"]);
        });
}

function loadWarehouses() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/warehouses", requestOptions)
        .then((response) => {
            return response.data;
        }, () => {
            Promise.reject(["failed to load suppliers"]);
        });
}

function loadSuppliers() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/supplier/376423", requestOptions)
        .then((response) => {
            return response.data.data;
        }, () => {
            Promise.reject(["failed to load suppliers"]);
        });
}


function loadCountries() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/country/376423", requestOptions)
        .then((response) => {
            return response.data.data;
        }, () => {
            Promise.reject(["failed to load countries"]);
        });
}

function loadBrands() {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/brand/376423", requestOptions)
        .then((response) => {
            return response.data.data;
        }, () => {
            Promise.reject(["failed to load brands"]);
        });
}


function findProducts(code) {
    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/api/products/find/376423/" + code, requestOptions)
        .then((response) => {
            if (response.data.data.length === 0) {
                return Promise.reject(["No product found"]);
            }
            return response.data.data;
        }, () => {
            Promise.reject(["failed to find products"]);
        });
}

function duplicateProduct(id, parameters) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/api/products/duplicate/376423/" + id, parameters, requestOptions)
        .then(() => {
            return true;
        }, (error) => {
            console.log(error.response);
            let data = error.response.data;

            if (typeof data["error"] !== "undefined") {
                return Promise.reject([data["error"]]);
            } else if (typeof data["errors"] !== "undefined") {
                let errors = [];
                Object.keys(data["errors"])
                    .map((error) => {
                        errors.push(data["errors"][error]);
                        return true;
                    });
                return Promise.reject(errors);
            } else {
                return Promise.reject(["Unknown error: ".error.response.statusText]);
            }
        });
}

function updateProduct(id, parameters) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/api/products/edit/376423/" + id, parameters, requestOptions)
        .then(() => {
            return true;
        }, (error) => {

            let data = error.response.data;

            if (typeof data["error"] !== "undefined") {
                return Promise.reject([data["error"]]);
            } else if (typeof data["errors"] !== "undefined") {
                let errors = [];
                Object.keys(data["errors"])
                    .map((error) => {
                        errors.push(data["errors"][error]);
                        return true;
                    });
                return Promise.reject(errors);
            } else {
                return Promise.reject(["Unknown error: ".error.response.statusText]);
            }
        });
}




// WEBPACK FOOTER //
// ./src/scenes/Tools/reducer/api.js